import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from '../Wrapper.js';
import { useBreakpointRef } from '../../../hooks/useBreakpointRef.js';
var BREAKPOINTS = Object.freeze([736, 744, 1128, 1512]);
var BREAKPOINT_VALUES = Object.freeze([{
  maxWidth: '360px',
  cardMargin: 'small'
}, {
  maxWidth: '736px',
  cardMargin: 'small'
}, {
  maxWidth: '744px',
  cardMargin: 'standard'
}, {
  maxWidth: '1128px',
  cardMargin: 'standard'
}, {
  maxWidth: '1512px',
  cardMargin: 'standard'
}]);
var CONTAINER_STYLE = Object.freeze({
  display: 'flex',
  flexDirection: 'row',
  width: '100%'
});
var DisplayWidthForCards = function DisplayWidthForCards(_ref) {
  var children = _ref.children,
    threeCardMax = _ref.threeCardMax;
  var _useBreakpointRef = useBreakpointRef({
      breakpoints: threeCardMax ? BREAKPOINTS.slice(0, 3) : BREAKPOINTS,
      breakpointValues: BREAKPOINT_VALUES
    }),
    ref = _useBreakpointRef.ref,
    breakpointValue = _useBreakpointRef.breakpointValue;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: CONTAINER_STYLE
  }, breakpointValue ? /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '0 auto',
      width: '100%',
      maxWidth: breakpointValue.maxWidth
    },
    className: "".concat(breakpointValue.cardMargin, "-card-margin")
  }, children) : null));
};
DisplayWidthForCards.displayName = "DisplayWidthForCards";
DisplayWidthForCards.propTypes = {
  children: PropTypes.node,
  threeCardMax: PropTypes.bool
};
export { DisplayWidthForCards };